import { DocumentItemOutput } from '@allocab/allocab-driver-service-types';
import { twMerge } from 'tailwind-merge';

import { DocumentCard } from './DocumentCard';
import { t } from '../../services/translation/translation';
import { noop } from '../../utils/common';
import { GradientButton } from '../button/GradientButton';
import { Modal } from '../modal/Modal';

type Props = {
  onClose: () => void;
  documentItem: DocumentItemOutput;
  vehicleId?: string;
  driverKey?: string;
};

export const DocumentItemModal = ({ onClose, documentItem, vehicleId, driverKey }: Props) => {
  const isLoading = false;
  const handleClose = isLoading ? noop : onClose;

  return (
    <Modal onClose={handleClose} className={twMerge('', documentItem.rectoVerso ? 'max-w-[1024px]' : 'max-w-[502px]')}>
      <Modal.Header onClose={handleClose} title={documentItem.title} />
      <Modal.Body>
        <div className="flex gap-4 flex-col lg:flex-row">
          <DocumentCard
            title={t('common.recto')}
            documentItem={documentItem}
            side="RECTO"
            vehicleId={vehicleId}
            driverKey={driverKey}
          />
          {documentItem.rectoVerso ? (
            <DocumentCard
              title={t('common.verso')}
              documentItem={documentItem}
              side="VERSO"
              vehicleId={vehicleId}
              driverKey={driverKey}
            />
          ) : null}
        </div>
        <GradientButton className="w-full mt-2" text={t('common.continue')} onClick={onClose} />
      </Modal.Body>
    </Modal>
  );
};
